export function start(chatId) {
    return {
        type: 'TRADER_CHAT_USER_TYPING_START',
        chatId
    };
}

export function stop(chatId) {
    return {
        type: 'TRADER_CHAT_USER_TYPING_STOP',
        chatId
    };
}
